export const ADMIN = 'admin';
export const OWNER = 'owner';
export const ROOT = 'root';
export const ADMINROLES = [ADMIN, OWNER, ROOT];
export const CUSTOMER = 'customer';
